
const data = {
    table: {
        columns: [
            {title: '用户账号', field: 'username', width: ''},
            {title: '用户名称', field: 'name', width: ''},
        ],
        data: [],
        total: 0,
        page: 1,
        pageSize: 10
    },
}

export default data
